import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_BRAZE_AGENTIC_AI } from "@lib/shared_constants";

export interface PostAppGroupIdBrazeMcpCallToolResult {
  tool_name: string;
  /** The tool's text content, flattened from its MCP content blocks. */
  content: string;
  /** Present only when the tool published a structured result alongside its text. */
  structured_content?: Record<string, unknown> | null;
}

export type PostAppGroupIdBrazeMcpCallToolToolError = FetchUserEncodedError<
  SHARED_CONSTANTS_BRAZE_AGENTIC_AI["BRAZE_MCP_ERROR_CODES"]["MCP_TOOL_ERROR"]
>;

export type PostAppGroupIdBrazeMcpCallToolTooLargeError = FetchUserEncodedError<
  SHARED_CONSTANTS_BRAZE_AGENTIC_AI["BRAZE_MCP_ERROR_CODES"]["RESPONSE_TOO_LARGE"]
>;

export type PostAppGroupIdBrazeMcpCallToolUnavailableError = FetchUserEncodedError<
  SHARED_CONSTANTS_BRAZE_AGENTIC_AI["BRAZE_MCP_ERROR_CODES"]["MCP_UNAVAILABLE"]
>;

export type PostAppGroupIdBrazeMcpCallToolErrors =
  | PostAppGroupIdBrazeMcpCallToolToolError
  | PostAppGroupIdBrazeMcpCallToolTooLargeError
  | PostAppGroupIdBrazeMcpCallToolUnavailableError;

export const isPostAppGroupIdBrazeMcpCallToolError = (
  error: FetchRequestError
): error is PostAppGroupIdBrazeMcpCallToolErrors => {
  return error instanceof FetchUserEncodedError;
};

export interface PostAppGroupIdBrazeMcpCallToolProps {
  appGroupId: string;
  toolName: string;
  arguments: Record<string, unknown>;
}
